import { render, staticRenderFns } from "./detailContent.vue?vue&type=template&id=4f353974&scoped=true&"
import script from "./detailContent.vue?vue&type=script&lang=js&"
export * from "./detailContent.vue?vue&type=script&lang=js&"
import style0 from "./detailContent.vue?vue&type=style&index=0&id=4f353974&lang=scss&scoped=true&"
import style1 from "./detailContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f353974",
  null
  
)

export default component.exports